customElements.define('post-add-modal-trigger', class extends HTMLElement {
    connectedCallback() {
        setTimeout(() => this.initialize(), 500);
    }

    initialize() {
        this.type = this.determineType();

        if (!this.shouldTrigger()) {
            return;
        }

        document.addEventListener('itemAddedToCart', event => {
            if (event.detail.eventSource === 'pdp') {
                if (!this.shouldTrigger()) {
                    return;
                }

                setTimeout(
                    () => this.triggerModal(event.detail.response),
                    parseInt(this.dataset.modalDelay) * 1000
                );
            }
        });
    }

    triggerModal(response) {
        const cart = document.getElementById('CartDrawer');
        const modalTitleTemplate = this.querySelector('[data-modal-title]');
        const modalIntroTemplate = this.querySelector('[data-modal-intro]');
        const url = `/collections/${this.dataset.collection}?view=${this.dataset.collectionTemplate}`;
        let modal, quickAddOpener;

        let header = `
            <h3 class="size-15 size-17-desktop uppercase letter-spacing-1 semi-heavy-weight pb-3 pt-1 center">
                ${modalTitleTemplate.innerHTML}
            </h3>
            ${modalIntroTemplate.innerHTML}
        `;
        let content = '';
        let cssClasses = this.dataset.modalCssClasses;

        switch (this.type) {
            case 'collection':
            case 'liquid':
                if (this.type === 'collection') {
                    content = `
                        <div class="custom-modal__loading" data-modal-loading>
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </div>
                    `;
                }

                if (!cssClasses) {
                    cssClasses = 'custom-modal--centered';
                }

                document.body.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                    <modal-dialog
                        id="PostAddToCartModal" data-animated="true" data-animation-duration="400"
                        class="custom-modal custom-modal--animate-drop custom-modal--post-add-to-cart ${cssClasses}"
                        ${cart.hasAttribute('open') ? 'data-unmovable="true" data-scope="CartDrawer"' : ''}
                        ${this.type === 'collection' ? `data-content-url="${url}"` : ''}
                    >
                        <div
                            class="custom-modal__content" role="dialog" tabindex="-1"
                            aria-label="${modalTitleTemplate.textContent}" aria-modal="true" 
                            style="--max-width: ${this.dataset.modalMaxWidth}px;"
                        >
                            <div class="custom-modal__content-info center">
                                <button
                                    id="ModalClose-PostAddToCartModal" aria-label="Close modal" type="button"
                                    class="custom-modal__toggle custom-modal__toggle--borderless custom-modal__toggle--corner custom-modal__toggle--small"
                                >
                                    <svg class="icon icon-close" aria-hidden="true" focusable="false">
                                        <use href="#icon-close"/>
                                    </svg>
                                </button>
                                ${header}
                                ${content}
                            </div>
                        </div>
                    </modal-dialog>
                `)));

                modal = document.getElementById('PostAddToCartModal');
                modal.show();
                if (response.options_with_values && response.options_with_values.length) {
                    modal.dataset.option1 = response.options_with_values[0].value;
                }
                break;
            case 'product':
                quickAddOpener = this.querySelector('post-add-to-cart-quick-add-opener');
                if (response.options_with_values && response.options_with_values.length) {
                    quickAddOpener.dataset.option1 = response.options_with_values[0].value;
                }
                quickAddOpener.openModal();
                break;
        }

        if (this.dataset.displayOnlyOnce) {
            localStorage.setItem(this.getStorageKey(), 'shown');
        }
    }

    shouldTrigger() {
        if (!this.type) {
            return false;
        }

        if (this.dataset.displayOnlyOnce) {
            const localstorageKey = this.getStorageKey();

            return !localStorage.getItem(localstorageKey);
        }

        return true;
    }

    determineType() {
        if (this.dataset.collection) {
            return 'collection';
        }

        if (this.querySelector('post-add-to-cart-quick-add-opener')) {
            return 'product';
        }

        const liquidTemplate = this.querySelector('[data-modal-intro]');
        if (liquidTemplate && liquidTemplate.innerHTML.length > 1) {
            return 'liquid';
        }

        return null;
    }

    getStorageKey() {
        return `post-add-to-cart-${BryanAnthonys.handleize(this.dataset.internalName)}`;
    }
});

customElements.define('post-add-to-cart-quick-add-opener', class extends QuickAddOpener {
    connectedCallback() {
        super.connectedCallback();

        this.modalClasses = ['custom-modal--centered', 'custom-modal--animate-drop'];
        this.modalAttributes = ['data-animated="true"', 'data-animation-duration="400"', 'data-inherits-from-modal', 'data-cart-related="true"'];

        this.addEventListener('renderedProductInQuickAdd', () => this.addModalHeader());
    }

    openModal() {
        super.openModal();

        this.modal.style.zIndex = 1010;
        const cart = document.getElementById('CartDrawer');
        if (cart.hasAttribute('open')) {
            this.modal.dataset.scope = 'CartDrawer';
            this.modal.dataset.unmovable = 'true';
        }
    }

    addModalHeader() {
        const modalContent = this.modal.querySelector('[data-quick-product-content]');
        if (!modalContent) {
            return;
        }

        const modalTitleTemplate = this.parentElement.querySelector('[data-modal-title]');
        const modalIntroTemplate = this.parentElement.querySelector('[data-modal-intro]');
        if (modalTitleTemplate.textContent) {
            let header = `
                <div class="quick-add-modal__header pt-3 pb-3 pl-5 pr-5">
                    <h3 class="size-13 size-14-desktop uppercase letter-spacing-1 semi-heavy-weight center height-150">
                        ${modalTitleTemplate.innerHTML}
                    </h3>
                    ${modalIntroTemplate.innerHTML}
                </div>
            `;

            modalContent.insertAdjacentHTML('beforebegin', BryanAnthonys.htmlReviewedForSafety(header));
        }

        if (this.dataset.option1) {
            const swatch = modalContent.querySelector(`.swatch-button[data-value="${this.dataset.option1}"]`);
            if (swatch) {
                swatch.click();
            }
        }
    }
});

customElements.define('modal-product-card', class extends HTMLElement {
    connectedCallback() {
        this.addEventListener('swatchButtonsVariantChanged', event => this.handleVariantChange(event));

        const option1 = this.closest('modal-dialog').dataset.option1;
        if (option1) {
            setTimeout(() => {
                const swatch = this.querySelector(`.swatch-button[data-value="${option1}"]`);
                if (swatch) {
                    swatch.click();
                }
            }, 500);
        }
    }

    handleVariantChange(event) {
        const variant = event.detail.variant;
        if (variant) {
            const imageInput = this.querySelector(`[data-image-variant-id="${variant.id}"]`);
            if (imageInput) {
                this.querySelector('[data-image]').src = imageInput.value;
            }

            const priceRegularElement = this.querySelector('.price__regular .price-item');
            if (priceRegularElement) {
                priceRegularElement.innerText = BryanAnthonys.formatMoney(variant.price, true);
            }
            const priceSpecialElement = this.querySelector('.price__sale .price-item--sale');
            if (priceSpecialElement) {
                priceSpecialElement.innerText = BryanAnthonys.formatMoney(variant.price, true);
            }
            const priceCompareElement = this.querySelector('.price__sale .price-item--regular');
            if (priceCompareElement) {
                const priceElement = priceCompareElement.closest('.price');
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    priceCompareElement.innerText = BryanAnthonys.formatMoney(variant.compare_at_price, true);
                    priceElement.classList.add('price--on-sale');
                } else {
                    priceCompareElement.innerText = '';
                    priceElement.classList.remove('price--on-sale');
                }
            }
        }
    }
});